// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Procedure = (...args: any[]) => void;

type DebouncedFunc<F extends Procedure> = (...args: Parameters<F>) => void;

export function debounce<F extends Procedure>(func: F, waitFor: number): DebouncedFunc<F> {
  let timeoutId: number;

  const debounced: DebouncedFunc<F> = (...args: Parameters<F>): void => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(() => func(...args), waitFor);
  };

  return debounced;
}
